<script>
    import Modal from "../Modal.svelte";
    import Card from "./Card.svelte";
    import List from "./List.svelte";
    import Icon from "fa-svelte";
    import { faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
    import { createEventDispatcher } from "svelte";

    export let opened;
    export let title;
    export let value = "";
    export let multiple = false;
    export let filter;

    const dispatch = createEventDispatcher();

    const getSet = (value) => {
        if (!value) return new Set();
        if (Array.isArray(value)) return new Set(value);
        return new Set([value]);
    };

    const handleAssetClick = (asset) => {
        const path = asset.fullPath;
        dispatch("asset", path);
        if (selected.has(path)) {
            value = multiple ? (value || []).filter((it) => it !== path) : "";
        } else {
            value = multiple ? [...(value || []), path] : path;
        }
    };

    $: selected = getSet(value);
</script>

<style>
    .relative {
        max-width: 15em;
    }

    .absolute {
        top: 1em;
        left: 1em;
    }

    .asset-modal {
        width: 90vw;
    }

    .asset-modal :global(.rounded-xl) {
        height: 100%;
    }
</style>

<Modal bind:opened>
    <div class="flex justify-between">
        <h1>{title || ''}</h1>
        <div class="cursor-pointer" on:click={() => (opened = false)}>
            <Icon icon={faTimes} />
        </div>
    </div>
    <div class="asset-modal">
        <List let:asset {filter}>
            <div
                class="border-2 rounded-xl overflow-hidden relative
                    cursor-pointer"
                class:border-blue-500={selected.has(asset.fullPath)}
                on:click={() => handleAssetClick(asset)}>
                {#if selected.has(asset.fullPath)}
                    <div
                        class="flex justify-center items-center bg-blue-500
                            text-white rounded-full w-16 h-16 absolute text-xl mt-1 ml-1">
                        <Icon icon={faCheck} />
                    </div>
                {/if}
                <Card {asset} />
            </div>
        </List>
    </div>
</Modal>
